import produce from 'immer';

import {
  OPEN_MODAL,
  CLOSE_MODAL
} from 'shared/actions/types';

const initialState = {
  modals: {
    allIds: [],
    disabledIds: []
  }
}

export default function(state = initialState, action) {
  switch(action.type) {
    case OPEN_MODAL:
      return produce(state, draft => {
        let id = action.payload.id;

        // ignore if already open
        if (draft.modals.allIds.indexOf(id) === -1) {
          // disable all existing modals
          draft.modals.disabledIds = [].concat(draft.modals.allIds);

          // add the new modal
          draft.modals.allIds.push(id);
        }
      });

    case CLOSE_MODAL:
      return produce(state, draft => {
        let id = action.payload.id;

        // remove id from cache
        draft.modals.allIds.splice(draft.modals.allIds.indexOf(id), 1);
        draft.modals.disabledIds.splice(draft.modals.disabledIds.indexOf(id), 1);

        // if none of the remaining modals are enabled, enable the most recent
        if (draft.modals.disabledIds.length === draft.modals.allIds.length) {
          draft.modals.disabledIds.pop();
        }
      });

    default:
      return state;
  }
}
